import { render, staticRenderFns } from "./deal-request-documents.vue?vue&type=template&id=8d36b722&scoped=true"
import script from "./deal-request-documents.vue?vue&type=script&lang=js"
export * from "./deal-request-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d36b722",
  null
  
)

export default component.exports